export function getChartColors(){
    const g = getComputedStyle(document.documentElement).getPropertyValue('--chart-positive').trim() || "#00ff00";
    const y = getComputedStyle(document.documentElement).getPropertyValue('--chart-adequate').trim() || "#ffff00";
    const r = getComputedStyle(document.documentElement).getPropertyValue('--chart-negative').trim() || "#ff0000";

    return [r, y, g];
}

export function getColorByName(color){
    let c = getComputedStyle(document.documentElement).getPropertyValue('--' + color).trim();
    if (c) return c;
    if (color.match(/^#(?:[0-9a-f]{3}){1,2}$/i)) return color;

    return "";
}